import { useFetchWithDefaults } from '../useFetchWithDefaults'

type Endpoint =
  | 'up'
  | `check`
  | `search`

export interface CompanyFromApi {
  city: string
  country_code: string
  ident: string
  post_code: string
  street: string
  title: string
}

export interface SearchParams {
  query: string
  country: App.Internals.Enums.Country
  per_page?: number
}

export const useFetchBusinessSearch = () => {
  const { public: { businessSearchApiUrl } } = useRuntimeConfig()
  const { get } = useFetchWithDefaults()

  const getUrl = ({
    country,
    endpoint,
  }: {
    country: App.Internals.Enums.Country
    endpoint: Endpoint
  }) => endpoint === 'up' ? `${businessSearchApiUrl}/${endpoint}` : `${businessSearchApiUrl}/${endpoint}/${country}`

  const search = ({ params: { query, country, per_page = 5 } }: { params: SearchParams }) =>
    get<{ data: CompanyFromApi[] }>({
      url: getUrl({
        country,
        endpoint: 'search',
      }),
      fetchOptions: {
        params: {
          q: query,
          'page[size]': per_page,
        },
      },
    })

  return {
    search,
  }
}
